<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-40" @mousedown="dontClose">
          <div class="modal-body m-0" style="overflow-y: auto;" :style="{maxHeight: getMaxHeightClient() + 'px'}">
            <div slot="formcontent" style="margin: 0px 20px 0px 20px;">
              <b-row>
                <b-col style="text-align:end;">
                  <i class="fa fa-times close-button" style="font-size:20px" @click="handleMouseDown"></i>
                </b-col>
              </b-row>
              <b-row class="panel-heading">
                <b-col cols="12" class="formTitleBlock">
                  <h4 class="content-block labelAccordionForm">
                    <i class="fa-light fa-file-code mr-2" style="font-size: 20px"></i>
                    {{ $t('administration.countries.select_country') }}
                  </h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="10" md="8" lg="10" xl="8">
                  <select class="cancelReasonCode form-group" style="width:100%" v-model="country">
                    <option value="" disabled>{{ $t('administration.countries.select_country') }}</option>
                    <option
                      v-for="(country, idCountry) in availableCountries"
                      :key="'popup-country-select-' + idCountry"
                      :value="idCountry">{{ country.name }}
                    </option>
                  </select>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="modal-footer">
              <b-button variant="primary" :disabled="!country"
                @click="selectCountry()">{{ $t('common.add_label') }}
              </b-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'ChoiceBICCountry',
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      mousedown: false,
      country: '',
      availableCountries: []
    }
  },
  created () {
    let that = this
    this.availableCountries = Object.fromEntries(
      Object.entries(this.$engine.rights.getCountries()).filter(([, value]) =>
        value?.networks?.some(network => that.data.networks.includes(network))
      )
    )
    window.addEventListener('resize', this.changeMaxHeightClient)
    window.addEventListener('mousedown', this.handleMouseDown)
    window.addEventListener('mouseup', this.handleMouseUp)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  methods: {
    changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height:' + maxHeight + 'px')
    },
    dontClose (e) {
      e.stopPropagation()
    },
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight
    },
    handleMouseDown (e) {
      if (!this.mousedown) {
        if (e.target.closest('.modal-mask') || e.target.closest('.close-button')) {
          this.$emit('close')
        }
        this.mousedown = true
      }
    },
    handleMouseUp () {
      this.mousedown = false
    },
    selectCountry () {
      this.$emit('close')
      this.$bus.$emit('selected-bic-country', {
        idRTPBIC: this.data.idRTPBIC,
        idCountry: Number(this.country),
      })
    }
  }
}
</script>
<style scoped>
</style>
